import { useEffect, useState } from "react";

import { GetDoc } from "@/Utils/StateLib";
import { isNullish } from "@theorgchartdev/storybook";
import { useRightSidebarContext } from "@/providers/RightSidebarProvider";
import { compareorphans } from "@coreapp/utils/compareorphans";

export const useStagingArea = () => {
  const { stagingState, setStagingState } = useRightSidebarContext();
  const [isSearching, setSearching] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    return () => {
      setStagingState({ root: null, highlightedRecordIds: [] });
    };
  }, []);

  const searchTree = (anObj, searchQuery) => {
    const doc = GetDoc();
    const match = doc.MatchStdObj(searchQuery, anObj);
    let matchList = [];
    if (match) {
      matchList = [anObj];
    }

    const nC = anObj.GetNumChildren();
    for (let j = 0; j < nC; j++) {
      const childObj = anObj.GetIndexChild(j);
      matchList = [...matchList, ...searchTree(childObj, searchQuery, matchList)];
    }

    return matchList;
  };

  const searchParking = () => {
    let matchList = [];
    const topList = getTopLevel();
    const n = topList.length;
    for (let i = 0; i < n; i++) {
      matchList = [...matchList, ...searchTree(topList[i], searchQuery)];
    }

    return matchList;
  };

  const objectInTree = anObj => {
    if (anObj === null) return false;
    const branches = findDisconnectedBranchesFromObjMgr();

    for (const branch of branches) {
      const children = [branch];
      branch.GetAllChildren(children);

      for (const child of children) {
        if (child.GetObjectID() === anObj.GetObjectID()) {
          return true;
        }
      }
    }

    return false;
  };

  const findDisconnectedBranchesFromObjMgr = () => {
    const doc = GetDoc();
    if (doc == null) {
      return [];
    }

    const objDB = doc.GetObjDB();
    const boxClass = objDB.GetClassByName("Box");

    const roots = boxClass.GetRootObjs();
    const disconnectedBranches = [];

    for (const root of roots) {
      const fieldDef = root.GetFieldDefByID("Orphan");
      const v = root.GetFieldValue(fieldDef);
      if (v !== 1) {
        continue;
      }

      disconnectedBranches.push(root);
    }

    return disconnectedBranches;
  };

  const getTopLevel = () => {
    const disconnectedBranches = findDisconnectedBranchesFromObjMgr();
    disconnectedBranches.sort(compareorphans);
    return disconnectedBranches;
  };

  const getCurrentLevel = () => {
    const nextRoots = [];

    const n = stagingState.root.GetNumChildren();
    for (let i = 0; i < n; i++) {
      const o = stagingState.root.GetIndexChild(i);
      nextRoots.push(o);
    }

    return nextRoots;
  };

  const getDisconnectedBranches = () => {
    if (isSearching) {
      return searchParking();
    }

    if (isNullish(stagingState.root)) {
      return getTopLevel();
    }

    return getCurrentLevel();
  };

  const drillDown = obj => {
    setSearching(false);
    setStagingState(p => ({ ...p, root: obj }));
  };

  const drillUp = () => {
    if (isSearching) {
      setLevelToTop();
      return;
    }

    setStagingState(p => ({ ...p, root: p.root.GetParent() }));
  };

  const setLevelToTop = () => {
    setStagingState(p => ({ ...p, root: null }));
    setSearching(false);
  };

  const handleMouseEnterNode = node => () => {
    const recordId = node.GetObjectRecordID();

    setStagingState(p => ({
      ...p,
      highlightedRecordIds: p.highlightedRecordIds.filter(id => id !== recordId)
    }));
  };

  return {
    branches: getDisconnectedBranches(),
    totalDisconnectedCount: findDisconnectedBranchesFromObjMgr().length,
    isSearching,
    setSearching,
    searchQuery,
    setLevelToTop,
    setSearchQuery,
    handleMouseEnterNode,
    stagingState,
    drillDown,
    drillUp,
    objectInTree
  };
};
